// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* The main floating card that contains everything */
.messagingPrechat {
  background-color: white;
  padding: 40px;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
  color: #333;
}

/* An optional title (if you add one like <h2 className="prechat-title">) */
.prechat-title {
  margin-top: 0;
  margin-bottom: 24px;
  font-size: 24px;
  font-weight: 600;
}

/* The form element itself */
.prechatForm {
  display: flex;
  flex-direction: column;
}

/* Hides default list styling (like bullets) */
.prechatFormFieldsListView {
  list-style-type: none;
  padding: 0;
  margin: 0;
}

/* The "Email *" label text */
.prechatFormFieldName {
  display: block;
  text-align: left;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: #555;
}

/* The actual email input box */
.prechatFormField.email {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  font-size: 16px;
  box-sizing: border-box; /* This is important for correct width */
  margin-bottom: 20px;
}

/* A blue glow effect when the user clicks on the input box */
.prechatFormField.email:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

/* The submit button */
.startConversationButton {
  width: 100%;
  padding: 12px 15px;
  border: none;
  border-radius: 6px;
  background-color: #007bff; /* A nice blue */
  color: white;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

/* A hover effect for the button */
.startConversationButton:hover {
  background-color: #0056b3; /* A darker blue on hover */
}

/* Keeps the red asterisk next to the label */
.requiredFieldIndicator {
  color: red;
  display: contents;
}

.error-message {
  color: #d93025; /* A standard error red */
  font-size: 13px;
  text-align: left;
  margin-top: 5px;
  margin-bottom: 0;
}

/* Style for the input box when there is an error */
.prechatFormField.input-error {
  border-color: #d93025;
}

.prechatFormField.input-error:focus {
  border-color: #d93025;
  box-shadow: 0 0 0 2px rgba(217, 48, 37, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/components/prechat.css"],"names":[],"mappings":"AAAA,oDAAoD;AACpD;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA,2EAA2E;AAC3E;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA,4BAA4B;AAC5B;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA,8CAA8C;AAC9C;EACE,qBAAqB;EACrB,UAAU;EACV,SAAS;AACX;;AAEA,6BAA6B;AAC7B;EACE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,sBAAsB,EAAE,wCAAwC;EAChE,mBAAmB;AACrB;;AAEA,6DAA6D;AAC7D;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA,sBAAsB;AACtB;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB,EAAE,gBAAgB;EAC3C,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,sCAAsC;AACxC;;AAEA,kCAAkC;AAClC;EACE,yBAAyB,EAAE,2BAA2B;AACxD;;AAEA,6CAA6C;AAC7C;EACE,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,cAAc,EAAE,yBAAyB;EACzC,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA,mDAAmD;AACnD;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;AAC/C","sourcesContent":["/* The main floating card that contains everything */\n.messagingPrechat {\n  background-color: white;\n  padding: 40px;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n  width: 100%;\n  max-width: 400px;\n  text-align: center;\n  color: #333;\n}\n\n/* An optional title (if you add one like <h2 className=\"prechat-title\">) */\n.prechat-title {\n  margin-top: 0;\n  margin-bottom: 24px;\n  font-size: 24px;\n  font-weight: 600;\n}\n\n/* The form element itself */\n.prechatForm {\n  display: flex;\n  flex-direction: column;\n}\n\n/* Hides default list styling (like bullets) */\n.prechatFormFieldsListView {\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n}\n\n/* The \"Email *\" label text */\n.prechatFormFieldName {\n  display: block;\n  text-align: left;\n  margin-bottom: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #555;\n}\n\n/* The actual email input box */\n.prechatFormField.email {\n  width: 100%;\n  padding: 12px 15px;\n  border: 1px solid #dcdcdc;\n  border-radius: 6px;\n  font-size: 16px;\n  box-sizing: border-box; /* This is important for correct width */\n  margin-bottom: 20px;\n}\n\n/* A blue glow effect when the user clicks on the input box */\n.prechatFormField.email:focus {\n  outline: none;\n  border-color: #007bff;\n  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);\n}\n\n/* The submit button */\n.startConversationButton {\n  width: 100%;\n  padding: 12px 15px;\n  border: none;\n  border-radius: 6px;\n  background-color: #007bff; /* A nice blue */\n  color: white;\n  font-size: 16px;\n  font-weight: bold;\n  cursor: pointer;\n  transition: background-color 0.2s ease;\n}\n\n/* A hover effect for the button */\n.startConversationButton:hover {\n  background-color: #0056b3; /* A darker blue on hover */\n}\n\n/* Keeps the red asterisk next to the label */\n.requiredFieldIndicator {\n  color: red;\n  display: contents;\n}\n\n.error-message {\n  color: #d93025; /* A standard error red */\n  font-size: 13px;\n  text-align: left;\n  margin-top: 5px;\n  margin-bottom: 0;\n}\n\n/* Style for the input box when there is an error */\n.prechatFormField.input-error {\n  border-color: #d93025;\n}\n\n.prechatFormField.input-error:focus {\n  border-color: #d93025;\n  box-shadow: 0 0 0 2px rgba(217, 48, 37, 0.25);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
